import React, {FC} from 'react';
import classNames from 'classnames';
import Button from 'components/Button';
import DynamicAsset from 'components/DynamicAsset';
import {BACKGROUND_COLOR, BG} from 'constants/index';
import {Link} from 'gatsby';

import * as styles from './styles.module.scss';

type HalfImageBigButtonProps = {
	imageSrc: string;
	title?: string;
	text?: string;
	buttonText?: string;
	buttonLink?: string;
	backgroundColor?: BG;
	imagePosition?: 'left' | 'right'; // Add imagePosition prop
}

const HalfImageBigButton: FC<HalfImageBigButtonProps> = ({
	imageSrc,
	text,
	title,
	buttonText,
	buttonLink,
	backgroundColor = BG.transparent,
	imagePosition = 'left', // Default to 'left'
}) => {
	const bgColor = BACKGROUND_COLOR[backgroundColor];
	return (
		<div className={styles.parentContainer}>
			<div style={{backgroundColor: bgColor}}>
				<div className={classNames(styles.container, {
					[styles.imageLeft]: imagePosition === 'left',
					[styles.imageRight]: imagePosition === 'right',
				})}>
					<div className={styles.imageBox}>
						<DynamicAsset className={styles.image}
							imageSrc={imageSrc}
						/>
					</div>
					<div className={styles.info}>
						{title && (
							<h2>{title}</h2>
						)}
						{text && (
							<p className={classNames({
								[styles.highlightText]: backgroundColor !== 'transparent',
							})}>
								{text}
							</p>
						)}
						{buttonLink && (
							<Link to={buttonLink}>
								<Button variant='primary' className={styles.button}>
									{buttonText}
								</Button>
							</Link>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default HalfImageBigButton;
